import React from 'react';
import './AboutModal.css';

const AboutModal = ({ isOpen, onClose }) => {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content about-modal" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h2>About Jeffrey Discs</h2>
                    <button className="close-button" onClick={onClose}>&times;</button>
                </div>
                
                <div className="about-content">
                    <section className="about-section">
                        <h3>In Memory of Jeffrey Lucas Gurmendi Marshall</h3>
                        <p>
                            Jeffrey Discs is a memorial project honoring Jeffrey Lucas Gurmendi Marshall,
                            who we lost to suicide in 2024. Jeffrey loved playing disc golf with us, and this
                            project combines our love for him with his love of the game.
                        </p>
                    </section>

                    <section className="about-section">
                        <h3>What Are Jeffrey Discs?</h3>
                        <p>
                            In 2025, we created 20 custom disc golf discs, each with a QR code linking to its
                            own journey page, and released them into the world (Jeffrey would have been 20 years old in 2025). Each year we will
                            launch a new disc to commemorate Jeffrey and the age he would have been. These discs
                            travel the world as people find them, play with them, and pass them along. Each disc
                            carries Jeffrey's memory and creates connections between people through shared experiences.
                        </p>
                    </section>

                    <section className="about-section">
                        <h3>Our Mission</h3>
                        <ul className="mission-list">
                            <li>Keep Jeffrey's memory alive and present in the world with us</li>
                            <li>Enable others to understand Jeffrey's story and be inspired by our love for him</li>
                            <li>Create a way for others to express kindness and joy, and to engage with their own grief</li>
                            <li>Connect with others' stories and their loved ones' stories</li>
                            <li>See how Jeffrey's presence and memory spreads throughout the world</li>
                        </ul>
                    </section>

                    <section className="about-section">
                        <h3>How to Participate</h3>
                        <div className="participation-steps">
                            <div className="step">
                                <div className="step-header">
                                    <div className="step-number">1</div>
                                    <h4>Find a Disc</h4>
                                </div>
                                <p className="step-description">
                                    If you come across a Jeffrey Disc at a disc golf course (or anywhere else!), scan the QR code or visit the URL printed on it.
                                </p>
                            </div>
                            
                            <div className="step">
                                <div className="step-header">
                                    <div className="step-number">2</div>
                                    <h4>Update Its Location</h4>
                                </div>
                                <p className="step-description">
                                    Share where you found it by uploading photos and your location. Your submission will be reviewed before appearing on the disc's journey.
                                </p>
                            </div>
                            
                            <div className="step">
                                <div className="step-header">
                                    <div className="step-number">3</div>
                                    <h4>Share Your Thoughts</h4>
                                </div>
                                <p className="step-description">
                                    If you've also lost a loved one, you can share your grief here. You can also share a moment of kindness or joy to honor Jeffrey's kind and joyous spirit.
                                </p>
                            </div>
                            
                            <div className="step">
                                <div className="step-header">
                                    <div className="step-number">4</div>
                                    <h4>Pass It Along</h4>
                                </div>
                                <p className="step-description">
                                    Play a round or a hole, then leave the disc at another hole or course for the next person to find. Let it continue its journey.
                                </p>
                            </div>
                        </div>
                    </section>

                    <section className="about-section foundation-section">
                        <h3>The Jeffrey Lucas Gurmendi Marshall Foundation</h3>
                        <p>
                            To honor Jeffrey's memory, continue his legacy of joy and kindness, and promote mental well being in youth and families, 
                            we've established the Jeffrey Lucas Gurmendi Marshall Foundation.
                        </p>
                        <a 
                            href="https://jlgmfoundation.org" 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="foundation-link"
                        >
                            Visit the JLGM Foundation →
                        </a>
                    </section>

                    <section className="about-section gratitude-section">
                        <p className="gratitude">
                            Thank you for helping us honor Jeffrey's memory and for sharing in this journey with us.
                        </p>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default AboutModal;